exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Theme Colors */\n.chatbot-ask-button {\n  position: absolute;\n  bottom: 30px;\n  right: 30px;\n  width: 52px;\n  width: 58px;\n  height: 48px;\n  z-index: 999;\n}\n.chatbot-ask-button .anticon {\n  font-size: 25px;\n  margin-top: 3px;\n}\n.chatbot-ask-button .anticon.gray {\n  color: #9ba0aa;\n}\n", ""]);

// exports
